function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 540,
  height: 398.515,
  rx: 20,
  fill: "#808080"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 10.6113,
  y: 10.6113,
  width: 518.777,
  height: 377.293,
  rx: 15,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6113 25.6113C10.6113 17.327 17.3271 10.6113 25.6113 10.6113H514.389C522.673 10.6113 529.389 17.3271 529.389 25.6113V61.31H10.6113V25.6113Z",
  fill: "#2896C9"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 27.1179,
  y: 29.4761,
  width: 15.3275,
  height: 2.35808,
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 27.1179,
  y: 35.3711,
  width: 15.3275,
  height: 2.35808,
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 27.1179,
  y: 41.2666,
  width: 15.3275,
  height: 2.35808,
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 27.1179,
  y: 261.747,
  width: 9.43231,
  height: 22.4017,
  rx: 4,
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M396.598 257.349C396.598 257.679 396.327 257.95 395.997 257.95C395.667 257.95 395.384 257.679 395.384 257.349C395.384 257.019 395.655 256.747 395.997 256.747C396.339 256.747 396.598 257.019 396.598 257.349Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M32.9594 217.462H278.07C279.709 217.462 281.029 218.782 281.029 220.421V333.456C281.029 335.094 279.697 336.415 278.07 336.415H32.9594C31.3323 336.415 30 335.094 30 333.456V220.421C30 218.782 31.3323 217.462 32.9594 217.462Z",
  fill: "#F4F4F4"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M276.584 81H508.065C509.633 81 510.918 82.2734 510.918 83.8533V202.948C510.918 204.516 509.645 205.789 508.077 205.789H276.596C275.028 205.789 273.743 204.516 273.743 202.936V83.8415C273.743 82.2734 275.016 81 276.584 81V81Z",
  fill: "#F4F4F4"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M256.576 81H34.0205C31.8001 81 30 82.8 30 85.0205V201.769C30 203.989 31.8001 205.789 34.0205 205.789H256.576C258.796 205.789 260.596 203.989 260.596 201.769V85.0205C260.596 82.8 258.796 81 256.576 81Z",
  fill: "#F4F4F4"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M295.944 217.462H371.933C373.312 217.462 374.444 218.582 374.444 219.973V333.904C374.444 335.283 373.324 336.415 371.933 336.415H295.956C294.564 336.415 293.444 335.295 293.444 333.904V219.973C293.444 218.594 294.564 217.462 295.956 217.462H295.944Z",
  fill: "#F4F4F4"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M508.442 336.415H389.442C388.086 336.415 386.978 335.283 386.978 333.904V219.973C386.978 218.582 388.086 217.462 389.442 217.462H508.442C509.798 217.462 510.907 218.582 510.907 219.973V333.904C510.907 335.283 509.798 336.415 508.442 336.415Z",
  fill: "#F4F4F4"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M367.146 271.167H316.058V275.199H367.146V271.167Z",
  fill: "#4B8CBC"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M307.298 269.705H300.731V276.662H307.298V269.705Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M367.146 284.242H316.058V288.275H367.146V284.242Z",
  fill: "#4B8CBC"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M307.298 282.78H300.731V289.737H307.298V282.78Z",
  fill: "white"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M367.146 297.306H316.058V301.338H367.146V297.306Z",
  fill: "#4B8CBC"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M307.298 295.844H300.731V302.801H307.298V295.844Z",
  fill: "white"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M367.146 310.37H316.058V314.402H367.146V310.37Z",
  fill: "#4B8CBC"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M307.298 308.92H300.731V315.876H307.298V308.92Z",
  fill: "white"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M367.146 323.445H316.058V327.478H367.146V323.445Z",
  fill: "#4B8CBC"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M307.298 321.984H300.731V328.94H307.298V321.984Z",
  fill: "white"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M423.528 319.543H394.523V322.208H423.528V319.543Z",
  fill: "#B7D3FF"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M434.552 319.543H425.39V322.208H434.552V319.543Z",
  fill: "#B7D3FF"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M451.094 319.543H436.415V322.208H451.094V319.543Z",
  fill: "#B7D3FF"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M479.744 319.543H452.945V322.208H479.744V319.543Z",
  fill: "#B7D3FF"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M503.985 319.543H481.595V322.208H503.985V319.543Z",
  fill: "#B7D3FF"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M404.793 324.389H394.523V327.054H404.793V324.389Z",
  fill: "#B7D3FF"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M416.913 324.389H406.656V327.054H416.913V324.389Z",
  fill: "#B7D3FF"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M423.528 324.389H418.776V327.054H423.528V324.389Z",
  fill: "#B7D3FF"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M427.937 324.389H425.39V327.054H427.937V324.389Z",
  fill: "#B7D3FF"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M444.479 324.389H429.8V327.054H444.479V324.389Z",
  fill: "#B7D3FF"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M473.13 324.389H446.33V327.054H473.13V324.389Z",
  fill: "#B7D3FF"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M485.262 324.389H474.993V327.054H485.262V324.389Z",
  fill: "#B7D3FF"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M503.986 324.389H487.114V327.054H503.986V324.389Z",
  fill: "#B7D3FF"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M205.865 162.235H200.029V187.773H205.865V162.235Z",
  fill: "#FEDF36"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M192.731 95.8323H186.895V187.774H192.731V95.8323Z",
  fill: "#34668E"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M179.596 124.282H173.76V187.773H179.596V124.282Z",
  fill: "white"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M166.462 134.504H160.626V187.773H166.462V134.504Z",
  fill: "#FEDF36"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M152.962 169.534H147.126V187.774H152.962V169.534Z",
  fill: "#34668E"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M139.827 152.013H133.991V187.773H139.827V152.013Z",
  fill: "white"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M126.327 135.967H120.491V187.774H126.327V135.967Z",
  fill: "#FEDF36"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M244.904 169.534H239.067V187.774H244.904V169.534Z",
  fill: "#FEDF36"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M231.769 152.013H225.933V187.773H231.769V152.013Z",
  fill: "#34668E"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M218.269 135.967H212.433V187.774H218.269V135.967Z",
  fill: "white"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M113.193 112.61H107.357V187.773H113.193V112.61Z",
  fill: "#34668E"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M244.916 188.846V187.266H107.345V188.846H244.916Z",
  fill: "white"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M88.7516 94.665H44.0542V117.491H88.7516V94.665Z",
  fill: "#B4E6F3"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M334.074 107.658L328.226 115.923C325.114 113.364 321.14 111.832 316.813 111.832V101.727C323.322 101.727 329.323 103.944 334.086 107.67L334.074 107.658Z",
  fill: "#15568C"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M316.813 147.769V157.873C301.332 157.873 288.787 145.352 288.728 129.883L298.856 130.661C299.304 140.188 307.18 147.769 316.813 147.769V147.769Z",
  fill: "#53D6F2"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M336.444 149.855C331.374 154.819 324.442 157.873 316.802 157.873V147.768C321.482 147.768 325.739 145.976 328.934 143.052L336.444 149.855Z",
  fill: "#2F8AD3"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M344.885 129.789C344.885 137.641 341.655 144.751 336.444 149.844L328.933 143.041C332.517 139.763 334.769 135.035 334.769 129.789C334.769 124.2 332.223 119.213 328.214 115.911L334.062 107.646C340.641 112.787 344.874 120.793 344.874 129.789H344.885Z",
  fill: "#2772AC"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M316.813 101.715V111.82C306.885 111.82 298.833 119.873 298.833 129.788C298.833 130.083 298.833 130.366 298.856 130.661L288.728 129.883V129.8C288.728 114.296 301.297 101.715 316.813 101.715Z",
  fill: "white"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M339.227 174.097H294.553V178.306H339.227V174.097Z",
  fill: "white"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M339.227 181.866H294.553V186.075H339.227V181.866Z",
  fill: "white"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M418.765 174.097H374.091V178.306H418.765V174.097Z",
  fill: "white"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M418.765 181.866H374.091V186.075H418.765V181.866Z",
  fill: "white"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M491.028 174.097H446.343V178.306H491.028V174.097Z",
  fill: "white"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M491.028 181.866H446.343V186.075H491.028V181.866Z",
  fill: "white"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M70.8538 132.347H44.0542V136.533H70.8538V132.347Z",
  fill: "white"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M88.61 132.347H71.7969V136.533H88.61V132.347Z",
  fill: "white"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M88.61 141.036H75.2869V145.222H88.61V141.036Z",
  fill: "white"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M74.1783 141.036H60.8669V145.222H74.1783V141.036Z",
  fill: "white"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M59.759 141.036H44.2192V145.222H59.759V141.036Z",
  fill: "white"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M70.8538 149.726H44.0542V153.911H70.8538V149.726Z",
  fill: "white"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M88.61 149.726H71.7969V153.911H88.61V149.726Z",
  fill: "white"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M70.8538 167.281H44.0542V171.467H70.8538V167.281Z",
  fill: "white"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M88.61 167.281H71.7969V171.467H88.61V167.281Z",
  fill: "white"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M88.61 175.983H75.2869V180.169H88.61V175.983Z",
  fill: "white"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M74.1783 175.983H60.8669V180.169H74.1783V175.983Z",
  fill: "white"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M59.759 175.983H44.2192V180.169H59.759V175.983Z",
  fill: "white"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M70.8538 184.673H44.0542V188.858H70.8538V184.673Z",
  fill: "white"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M88.61 184.673H71.7969V188.858H88.61V184.673Z",
  fill: "white"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M263.627 315.605H232.37V319.814H263.627V315.605Z",
  fill: "white"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M202.364 315.605H171.107V319.814H202.364V315.605Z",
  fill: "white"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M164.859 315.605H133.602V319.814H164.859V315.605Z",
  fill: "white"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M128.603 315.605H97.3469V319.814H128.603V315.605Z",
  fill: "white"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M91.0979 315.605H59.8416V319.814H91.0979V315.605Z",
  fill: "white"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M226.121 315.605H208.613V319.814H226.121V315.605Z",
  fill: "white"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M394.523 257.596L422.384 229.134L446.802 247.374L462.565 230.926L479.85 244.615L496.31 235.583L503.985 238.625V257.596H394.523Z",
  fill: "url(#paint0_linear_131_89)"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M394.523 310.134V271.462L421.535 293.356L446.601 285.787L462.4 271.462L479.85 285.834L496.31 290.539L503.985 310.134H394.523Z",
  fill: "#59CAC8"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M413.341 135.613C410.936 142.687 404.227 147.769 396.351 147.769V157.873C409.108 157.873 419.884 149.361 423.304 137.712L413.353 135.613H413.341Z",
  fill: "#EFEFEF"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M383.134 141.968L375.022 148.064C371.014 143.383 368.502 137.358 368.29 130.744L378.442 131.227C378.76 135.354 380.481 139.103 383.134 141.968V141.968Z",
  fill: "#4B8CBC"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M396.34 147.768V157.873C387.803 157.873 380.163 154.065 375.011 148.051L383.123 141.956C386.4 145.528 391.105 147.757 396.34 147.757V147.768Z",
  fill: "#B7D1E4"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M424.424 129.788C424.424 132.535 424.035 135.2 423.292 137.711L413.341 135.613C413.978 133.785 414.319 131.828 414.319 129.788C414.319 128.456 414.178 127.159 413.895 125.909L423.481 122.561C424.094 124.872 424.424 127.289 424.424 129.788V129.788Z",
  fill: "white"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M423.481 122.573L413.896 125.921C412.127 117.856 404.947 111.82 396.351 111.82C395.055 111.82 393.769 111.961 392.555 112.232L390.657 102.293C392.496 101.916 394.394 101.715 396.351 101.715C409.356 101.715 420.31 110.57 423.493 122.573H423.481Z",
  fill: "white"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M378.371 129.788C378.371 130.272 378.395 130.744 378.43 131.215L368.278 130.732C368.278 130.413 368.267 130.107 368.267 129.788C368.267 116.23 377.876 104.923 390.657 102.281L392.555 112.221C384.443 113.954 378.371 121.17 378.371 129.788V129.788Z",
  fill: "#265B9D"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M463.45 147.014L460.161 156.588C456.175 155.338 452.568 153.216 449.561 150.445L456.847 143.394C458.746 145.033 460.986 146.283 463.438 147.014H463.45Z",
  fill: "#FFEF99"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M492.596 144.385C487.668 152.473 478.766 157.873 468.591 157.873C465.655 157.873 462.826 157.425 460.173 156.588L463.462 147.014C465.089 147.497 466.811 147.769 468.603 147.769C474.852 147.769 480.346 144.585 483.577 139.739L492.608 144.385H492.596Z",
  fill: "#FFF7CC"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M496.675 129.788C496.675 135.141 495.178 140.129 492.596 144.385L483.564 139.739C485.463 136.898 486.571 133.467 486.571 129.788C486.571 125.178 484.838 120.969 481.985 117.798L488.929 110.417C493.74 115.451 496.687 122.278 496.687 129.788H496.675Z",
  fill: "white"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M488.917 110.417L481.973 117.797C478.683 114.131 473.908 111.82 468.591 111.82C464.735 111.82 461.163 113.034 458.227 115.109L452.957 106.467C457.425 103.472 462.802 101.715 468.591 101.715C476.584 101.715 483.812 105.052 488.917 110.417V110.417Z",
  fill: "#FEDF36"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M458.227 115.109C456.329 116.453 454.702 118.163 453.44 120.132L445.481 113.836C447.486 110.935 450.033 108.436 452.957 106.455L458.227 115.097V115.109Z",
  fill: "#FEE666"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M456.859 143.395L449.573 150.446C443.996 145.328 440.506 137.971 440.506 129.801C440.506 123.87 442.345 118.376 445.47 113.848L453.428 120.144C451.636 122.927 450.599 126.252 450.599 129.801C450.599 135.248 453.016 140.117 456.836 143.407L456.859 143.395Z",
  fill: "#FEE666"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M339.191 236.515C339.191 239.109 337.081 241.22 334.487 241.22C331.893 241.22 329.782 239.121 329.782 236.515C329.782 233.909 331.893 231.811 334.487 231.811C337.081 231.811 339.191 233.921 339.191 236.515Z",
  fill: "white"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M342.386 251.913V256.983C342.386 257.938 341.82 258.787 340.948 259.165C339.002 259.99 336.904 260.438 334.699 260.438C332.117 260.438 329.664 259.813 327.46 258.705C326.658 258.304 326.151 257.49 326.151 256.594V251.925C326.151 246.973 329.794 242.929 334.263 242.929C336.503 242.929 338.531 243.943 339.993 245.57C341.467 247.197 342.374 249.449 342.374 251.925L342.386 251.913Z",
  fill: "white"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M395.738 257.596C395.738 258.268 395.196 258.811 394.524 258.811C393.852 258.811 393.309 258.268 393.309 257.596C393.309 256.924 393.852 256.382 394.524 256.382C395.196 256.382 395.738 256.924 395.738 257.596Z",
  fill: "white"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M423.269 293.109C423.269 293.781 422.726 294.323 422.054 294.323C421.382 294.323 420.84 293.781 420.84 293.109C420.84 292.437 421.382 291.894 422.054 291.894C422.726 291.894 423.269 292.437 423.269 293.109Z",
  fill: "white"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M463.603 271.462C463.603 272.134 463.061 272.676 462.389 272.676C461.717 272.676 461.175 272.134 461.175 271.462C461.175 270.79 461.717 270.247 462.389 270.247C463.061 270.247 463.603 270.79 463.603 271.462Z",
  fill: "white"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M395.738 271.462C395.738 272.134 395.196 272.676 394.524 272.676C393.852 272.676 393.309 272.134 393.309 271.462C393.309 270.79 393.852 270.247 394.524 270.247C395.196 270.247 395.738 270.79 395.738 271.462Z",
  fill: "white"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M447.804 285.799C447.804 286.471 447.262 287.013 446.59 287.013C445.918 287.013 445.375 286.471 445.375 285.799C445.375 285.127 445.918 284.584 446.59 284.584C447.262 284.584 447.804 285.127 447.804 285.799Z",
  fill: "white"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M481.053 285.834C481.053 286.506 480.511 287.049 479.839 287.049C479.167 287.049 478.625 286.506 478.625 285.834C478.625 285.162 479.167 284.62 479.839 284.62C480.511 284.62 481.053 285.162 481.053 285.834Z",
  fill: "white"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M497.465 290.433C497.465 291.105 496.923 291.647 496.251 291.647C495.579 291.647 495.036 291.105 495.036 290.433C495.036 289.761 495.579 289.218 496.251 289.218C496.923 289.218 497.465 289.761 497.465 290.433Z",
  fill: "white"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M505.2 310.134C505.2 310.806 504.658 311.349 503.986 311.349C503.314 311.349 502.771 310.806 502.771 310.134C502.771 309.462 503.314 308.92 503.986 308.92C504.658 308.92 505.2 309.462 505.2 310.134Z",
  fill: "white"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M423.598 229.134C423.598 229.806 423.056 230.349 422.384 230.349C421.712 230.349 421.17 229.806 421.17 229.134C421.17 228.462 421.712 227.92 422.384 227.92C423.056 227.92 423.598 228.462 423.598 229.134Z",
  fill: "white"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M463.768 230.879C463.768 231.551 463.226 232.094 462.554 232.094C461.882 232.094 461.34 231.551 461.34 230.879C461.34 230.207 461.882 229.665 462.554 229.665C463.226 229.665 463.768 230.207 463.768 230.879Z",
  fill: "white"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M481.1 244.568C481.1 245.24 480.558 245.782 479.886 245.782C479.214 245.782 478.671 245.24 478.671 244.568C478.671 243.896 479.214 243.354 479.886 243.354C480.558 243.354 481.1 243.896 481.1 244.568Z",
  fill: "white"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M505.2 238.555C505.2 239.227 504.658 239.769 503.986 239.769C503.314 239.769 502.771 239.227 502.771 238.555C502.771 237.883 503.314 237.34 503.986 237.34C504.658 237.34 505.2 237.883 505.2 238.555Z",
  fill: "white"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M446.802 248.565C447.473 248.565 448.016 248.021 448.016 247.351C448.016 246.68 447.473 246.136 446.802 246.136C446.131 246.136 445.588 246.68 445.588 247.351C445.588 248.021 446.131 248.565 446.802 248.565Z",
  fill: "white"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M497.513 235.536C497.513 236.209 496.97 236.751 496.298 236.751C495.626 236.751 495.084 236.209 495.084 235.536C495.084 234.864 495.626 234.322 496.298 234.322C496.97 234.322 497.513 234.864 497.513 235.536Z",
  fill: "white"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M60.8198 303.567C63.5788 300.254 81.4884 270.613 123.108 278.76C155.508 285.115 165.188 265.991 178.394 257.679C189.819 250.487 203.543 254.967 222.56 257.584C248.004 261.098 262.377 227.295 262.377 227.295V303.555H60.8198V303.567Z",
  fill: "#59CAC8"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M60.8198 303.567C67.0687 298.037 86.0866 281.613 107.345 282.71C128.603 283.818 132.989 290.385 149.943 287.025C167.653 283.511 179.608 264.293 197.353 267.229C221.841 271.285 240.623 275.341 262.377 252.573V303.555H60.8198V303.567Z",
  fill: "url(#paint1_linear_131_89)"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M60.8198 303.567C73.3176 296.021 82.7264 289.43 105.234 290.326C127.742 291.222 130.183 299.252 159.765 294.488C173.465 292.284 176.33 285.634 193.297 282.816C214.39 279.314 229.694 291.105 262.365 275.353V303.567H60.8198Z",
  fill: "url(#paint2_linear_131_89)"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M52.3309 228.556H48.5815V303.567H52.3309V228.556Z",
  fill: "white"
});

var _ref116 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2,
  filter: "url(#filter0_f_131_89)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 270.5,
  cy: 457,
  rx: 240.5,
  ry: 13,
  fill: "black"
}));

var _ref117 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_131_89",
  x: 5,
  y: 419,
  width: 531,
  height: 76,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 12.5,
  result: "effect1_foregroundBlur_131_89"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_131_89",
  x1: 449.254,
  y1: 225.349,
  x2: 449.254,
  y2: 257.136,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEE666"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_131_89",
  x1: 56.422,
  y1: 319.319,
  x2: 270.925,
  y2: 274.433,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEE666"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_131_89",
  x1: 59.405,
  y1: 303.614,
  x2: 418.47,
  y2: 278.571,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#72C9F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.24,
  stopColor: "#5EB3E4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#4F9DD8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#3C7AB6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2A5796"
})));

function SvgFeature3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 495,
    viewBox: "0 0 540 495",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3);
export default __webpack_public_path__ + "static/media/feature3.d4b0271a.svg";
export { ForwardRef as ReactComponent };